import styled, { css } from 'styled-components';

const regular = css`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
  color: var(--black);
`;

const bold = css`
  font-size: var(--font-size-text-xl);
  font-weight: var(--font-weight-semibold);
  line-height: 1.5;
`;

export const Ledger = styled.dl`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--spacing-small);
`;

export const Line = styled.div.attrs<{ $isTotal: boolean }>(({ $isTotal }) => ({
  className: $isTotal ? 'total' : undefined,
}))`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Key = styled.dt<{ $flipIcon: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-small);
  ${regular}

  &:is(.total &) {
    ${bold}
  }

  & svg {
    width: 18px;
    height: 18px;

    ${({ $flipIcon }) =>
      $flipIcon
        ? `
    transform: scaleX(-1);
    `
        : ''}

    & path {
      stroke: var(--grey-500);
    }
  }
`;

export const Value = styled.dd<{ $nonCurrency: boolean }>`
  ${regular}

  ${props =>
    props.$nonCurrency
      ? `
  color: var(--grey-500);
  text-transform: uppercase;
    `
      : ''}

  &:is(.total &) {
    ${bold}
  }
`;

export const Text = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-small);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
  color: var(--grey-500);

  & path {
    stroke: var(--grey-500);
  }
`;
